$(document).ready(function() {
    setTimeout(function() {
        $('#landingpageCarousel').carousel({
            interval: 1000 * 4
        });
    }, 1000);
    
	// Handle scrolling to anchor when page loads with hash.
	// Topic anchors are handled by home.html.erb with a dedicated offset logic.
    if (window.location.hash) {
        var hash = window.location.hash;
		if (hash.indexOf('#lp-topic-') === 0) {
			return;
		}

        var target = $(hash);
        if (target.length) {
            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: target.offset().top - 100
                }, 800);
            }, 500);
        }
    }
});


$(function () {
	$('#cb_agb').on('click', function () {
		checkSingInCheckboxes();
	});
});

$(function () {
	$('#cb_privacy').on('click', function () {
		checkSingInCheckboxes();
	});
});

export function checkSingInCheckboxes() {
	var btn = $('.btn-new-account');
	if (!$('#cb_privacy').is(':checked') || !$('#cb_agb').is(':checked')) {
		btn.removeClass('btn-primary');
		btn.addClass('disable');
		btn.attr('disabled', 'disabled');
		btn.disabled = true;
	}
	if ($('#cb_privacy').is(':checked') && $('#cb_agb').is(':checked')) {
		btn.addClass('btn-primary');
		btn.removeClass('disable');
		btn.removeAttr('disabled');
		btn.disabled = false;
	}
}

$('.close-flashs').on('click', function () {
	$('.flash-alert-box-wrapper').each(function (index) {
		this.remove();
	});
});